<form (ngSubmit)="onSubmit()">
  <div class="search-container">
    <div class="search-header">
      <div class="search-actions">
        <button
          type="button"
          class="advanced-search-toggle"
          [class.active]="isAdvancedSearchVisible"
          (click)="toggleAdvancedSearch()"
          aria-label="Toggle Data Axle advanced filters"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
              d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
            />
          </svg>
          <span>Advanced Filters</span>
          <span class="arrow" [class.open]="isAdvancedSearchVisible"
            >&#9662;</span
          >
          @if (filterCount > 0) {
            <span class="filter-count-badge">{{ filterCount }}</span>
          }
        </button>
      </div>
    </div>
    @if (isAdvancedSearchVisible) {
      <div class="advanced-search">
        <div class="form-row">
          <div class="form-group">
            <div class="text_field">
              <label for="phone">Phone</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">The telephone number for the place.</div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="phone"
              type="text"
              placeholder="Enter phone number"
              [(ngModel)]="searchForm.phone_number"
              name="phone"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.phone_number"
            />
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="postal_code">Postal Code</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The postal code for the location address. Full ZIP code
                      required; partial ZIPs may not work.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="postal_code"
              type="text"
              placeholder="Enter multiple postal codes separated by commas (e.g., 12345, 67890)"
              [(ngModel)]="searchForm.postal_code"
              name="postal_code"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.postal_code"
            />
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="city">City</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">The city name for the location.</div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="city"
              type="text"
              placeholder="Enter multiple cities separated by commas (e.g., New York, Los Angeles)"
              [(ngModel)]="searchForm.city"
              name="city"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.city"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group" role="group">
            <div class="text_field">
              <label for="state-dropdown">State</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">The state or province of the place.</div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <app-multiselect-filter
              [options]="states"
              [optionKey]="'name'"
              [valueKey]="'value'"
              [selectedValues]="selectedStates"
              [placeholder]="'Select states'"
              [styleClass]="'state-multiselect'"
              (apply)="onStateFilterChange($event)"
            ></app-multiselect-filter>
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="street">Street</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">The location address of the place.</div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="street"
              type="text"
              placeholder="Enter multiple streets separated by commas (e.g., Main St, 2nd Ave)"
              [(ngModel)]="searchForm.street"
              name="street"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.street"
            />
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="work_at_home">Work At Home</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The place is a work at home business.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <select
              id="work_at_home"
              [(ngModel)]="searchForm.work_at_home"
              name="work_at_home"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.work_at_home"
            >
              <option [ngValue]="undefined">Select</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="fips_code">FIPS Code</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The unique identifier for counties based on the Federal
                      Information Processing Standards (FIPS).
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="fips_code"
              type="text"
              placeholder="Enter FIPS code"
              [(ngModel)]="searchForm.fips_code"
              name="fips_code"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.fips_code"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <div class="text_field">
              <label for="location_sales_volume">Location Sales Volume</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      An estimation of the place's sales revenue.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div class="input-group">
              <input
                id="location_sales_volume"
                type="number"
                placeholder="Enter sales volume"
                [(ngModel)]="searchForm.location_sales_volume"
                name="location_sales_volume"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.location_sales_volume"
              />
              <select
                id="disbursedAmountOperator"
                [(ngModel)]="searchForm.location_sales_volume_operator"
                name="disbursedAmountOperator"
                [class.searched-field]="
                  searchForm.location_sales_volume_operator
                "
              >
                <option [ngValue]="undefined">Select</option>
                <option [ngValue]="'greater_than'">Greater than</option>
                <option [ngValue]="'less_than'">Less than</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="primary_sic_code">Primary SIC Code</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      An estimation of the place's sales revenue.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="primary_sic_code"
              type="text"
              placeholder="Enter multiple codes separated by commas (e.g., 1234, 5678)"
              [(ngModel)]="searchForm.primary_sic_code"
              name="primary_sic_code"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.primary_sic_code"
            />
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="sic_codes">SIC Codes</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The lines of business represented by Standard Industrial
                      Classification codes.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="sic_codes"
              type="text"
              placeholder="Enter multiple codes separated by commas (e.g., 1234, 5678)"
              [(ngModel)]="searchForm.sic_codes"
              name="sic_codes"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.sic_codes"
            />
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="primary_naics_code">Primary NAICS Code</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The primary line of business represented by a North
                      American Industry Classification System code.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="primary_naics_code"
              type="text"
              placeholder="Enter multiple codes separated by commas (e.g., 1234, 5678)"
              [(ngModel)]="searchForm.primary_naics_code"
              name="primary_naics_code"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.primary_naics_code"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <div class="text_field">
              <label for="naics_codes">NAICS Codes</label>
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The lines of business represented by North American
                      Industry Classification System codes.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <input
              id="naics_codes"
              type="text"
              placeholder="Enter multiple codes separated by commas (e.g., 1234, 5678)"
              [(ngModel)]="searchForm.naics_codes"
              name="naics_codes"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.naics_codes"
            />
          </div>
          <div class="form-group">
            <div class="text_field">
              <label for="location_employee_count"
                >Location Employee Count</label
              >
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The number of employees who work at this place.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div class="input-group">
              <input
                id="location_employee_count"
                type="number"
                placeholder="Enter employee count"
                [(ngModel)]="searchForm.location_employee_count"
                name="location_employee_count"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.location_employee_count"
              />
              <select
                id="locationEmployeeCountOperator"
                [(ngModel)]="searchForm.location_employee_count_operator"
                name="locationEmployeeCountOperator"
                [class.searched-field]="
                  searchForm.location_employee_count_operator
                "
              >
                <option [ngValue]="undefined">Select</option>
                <option [ngValue]="'greater_than'">Greater than</option>
                <option [ngValue]="'less_than'">Less than</option>
              </select>
            </div>
          </div>
          <div class="form-group date-range">
            <div class="text_field">
              <label for="opened_for_business_from"
                >Opened For Business On is between</label
              >
              <div class="right-actions">
                <a href="javascript:void(0);" class="has-tooltip">
                  <div class="tooltip" role="tooltip">
                    <div class="arrow-down"></div>
                    <div class="name">
                      The date when the place opened for business.
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div class="date-inputs">
              <input
                id="opened_for_business_from"
                type="date"
                [(ngModel)]="searchForm.opened_for_business_from"
                name="opened_for_business_from"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.opened_for_business_from"
                aria-label="Start date"
              />
              <span class="date-separator">and</span>
              <input
                id="opened_for_business_to"
                type="date"
                [(ngModel)]="searchForm.opened_for_business_to"
                name="opened_for_business_to"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.opened_for_business_to"
                aria-label="End date"
              />
            </div>
            <div class="error-container">
              @if (isDateRangeInvalid()) {
                <span class="error-message"
                  >End date must be after start date</span
                >
              }
            </div>
          </div>
        </div>
        <div class="form-button">
          <div class="button-group search-split-group">
            <div
              class="search-split-button"
              [class.visible-options]="tourService.isTourMode"
              [class.open]="isSearchTypeDropdownOpen"
              id="tour-data-axle-search"
            >
              <button
                type="button"
                class="search-button main"
                [class.disabled]="!isFormValid"
                (click)="onSubmit()"
                [title]="matchType === 'all' ? 'Match All' : 'Match Any'"
              >
                <span class="search-button-label">Search</span>
              </button>
              <button
                type="button"
                id="tour-search-type-dropdown-toggle"
                class="search-button dropdown"
                [class.disabled]="!isFormValid"
                (click)="isSearchTypeDropdownOpen = !isSearchTypeDropdownOpen"
                aria-label="Search Type Dropdown"
              >
                <svg width="12" height="12" viewBox="0 0 20 20">
                  <path
                    d="M5.5 8l4.5 4 4.5-4"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
              @if (isSearchTypeDropdownOpen) {
                <div
                  id="tour-dataxle-search-options"
                  class="search-type-dropdown"
                  (appClickOutside)="isSearchTypeDropdownOpen = false"
                >
                  <div
                    class="search-type-option"
                    [class.selected]="matchType === 'all'"
                    (click)="
                      matchType = 'all'; isSearchTypeDropdownOpen = false
                    "
                    (keyup.enter)="
                      matchType = 'all'; isSearchTypeDropdownOpen = false
                    "
                    tabindex="0"
                    role="button"
                    [attr.aria-pressed]="matchType === 'all'"
                  >
                    Match All
                  </div>
                  <div
                    class="search-type-option"
                    [class.selected]="matchType === 'any'"
                    (click)="
                      matchType = 'any'; isSearchTypeDropdownOpen = false
                    "
                    (keyup.enter)="
                      matchType = 'any'; isSearchTypeDropdownOpen = false
                    "
                    tabindex="0"
                    role="button"
                    [attr.aria-pressed]="matchType === 'any'"
                  >
                    Match Any
                  </div>
                </div>
              }
            </div>
            <button
              type="button"
              class="reset-button"
              (click)="resetForm()"
              title="Reset form"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</form>
